import {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import { getUserById, updateUser } from "../../HTTP/admin";
import { countries } from "../../global/countriesAndSources";
import useCurrentLanguage from "../../Helper/useCurrentLanguage";

export default function EditUser() {
  const currentLanguage = useCurrentLanguage();
  const isFrenchLanguage = currentLanguage.startsWith("fr");
  const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 1) {
        window.location.href = '/'
    }

  const { id } = useParams();
  const [formData, setFormData] = useState({
    lastname: '',
    firstname: '',
    email: '',
    country:'',
    address: '',
    phone: '',
    bio: '',
    admin: false,
    private: false,
    admin_access: 0,
    restricted_searches: 0,
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getUserById(id);
        setFormData({
          ...user,
          restricted_searches: Number(user?.restricted_searches) === 1 ? 1 : 0
        });
      } catch (error) {
        console.error("Erreur lors de la récupération de l'utilisateur:", error);
      }
    };
    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const request = {
      firstname: formData.firstname,
      lastname: formData.lastname,
      email : formData.email,
      admin : formData.admin,
      address: formData.address,
      phone: formData.phone,
      bio: formData.bio,
      private: formData.private,
      country: formData.country,
      admin_access: formData.admin_access,
      restricted_searches: Number(formData.restricted_searches) === 1 ? 1 : 0,
    }
    try {
      const req = await updateUser(id, request);
      req ? alert("User succesfully modified") : alert("An error occured while modifying the user");
      window.location.href = "/admin/users";
    } catch (err) {
      alert("An error occured while modifying the user");
    }
  };

  return (
    <div className="mt-8 max-w-md mx-auto p-6 bg-white rounded-lg shadow-md md:overflow-y-auto" style={{ maxHeight: window.innerWidth >= 768 ? 'calc(100vh - 100px)' : undefined }}>
      <h2 className="text-2xl font-bold mb-6 text-center">Formulaire Utilisateur</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="lastname" className="block text-gray-700 text-sm font-bold mb-2">
            Nom
          </label>
          <input
            type="text"
            id="lastname"
            name="lastname"
            value={formData.lastname}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="firstname" className="block text-gray-700 text-sm font-bold mb-2">
            Prénom
          </label>
          <input
            type="text"
            id="firstname"
            name="firstname"
            value={formData.firstname}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="address" className="block text-gray-700 text-sm font-bold mb-2">
            Adresse
          </label>
          <input
            type="address"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="phone" className="block text-gray-700 text-sm font-bold mb-2">
            Téléphone
          </label>
          <input
            type="phone"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="bio" className="block text-gray-700 text-sm font-bold mb-2">
            Bio
          </label>
          <textarea
            id="bio"
            name="bio"
            value={formData.bio}
            onChange={handleChange}
            rows="4"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          ></textarea>
        </div>
        <div className="mb-4">
            <label htmlFor="country" className="block text-gray-700 text-sm font-bold mb-2">
              Pays
            </label>
            <select value={formData.country} onChange={handleChange} className={`w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isFrenchLanguage ? "notranslate" : ""}`} translate={isFrenchLanguage ? "no" : undefined} name="country">
                {
                  countries.map((c, i) => <option value={c.code} key={i} className={isFrenchLanguage ? "notranslate" : ""} translate={isFrenchLanguage ? "no" : undefined}>{c.name}</option>)
                }
            </select>
        </div>
        <div className="mb-6">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="admin"
              checked={formData.private}
              onChange={handleChange}
              className="form-checkbox h-5 w-5 text-blue-600"
            />
            <span className="ml-2 text-gray-700">Utilisateur privé</span>
          </label>
        </div>
        <div className="mb-6">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="admin"
              checked={formData.admin}
              onChange={handleChange}
              className="form-checkbox h-5 w-5 text-blue-600"
            />
            <span className="ml-2 text-gray-700">Utilisateur modérateur</span>
          </label>
        </div>
        <div className="mb-6">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="restricted_searches"
              checked={Number(formData.restricted_searches) === 1}
              onChange={(e) => setFormData((prevData) => ({
                ...prevData,
                restricted_searches: e.target.checked ? 1 : 0
              }))}
              className="form-checkbox h-5 w-5 text-blue-600"
            />
            <span className="ml-2 text-gray-700">Activer la restriction de recherche</span>
          </label>
        </div>
        <div className="mb-6">
          <label htmlFor="admin_access" className="block text-gray-700 text-sm font-bold mb-2">
            Accès administrateur
          </label>
          <select value={formData.admin_access} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" name="admin_access">
            <option value="0">Aucun accès</option>
            <option value="1">Accès aux utilisateurs</option>
            <option value="2">Accès aux tarifs abonnements</option>
            <option value="3">Accès aux abonnements</option>
            <option value="4">Accès aux CSE</option>
            <option value="5">Accès aux Forums Globaux</option>
            <option value="6">Accès aux liens thématiques</option>
            <option value="7">Accès aux tutoriels</option>
          </select>
        </div>
        <div className="flex items-center justify-end">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Enregistrer
          </button>
        </div>
      </form>
    </div>
  );
}
